import TextField from "components/FormFields/TextField";
import FormattedMessage from "components/FormattedMessage/index";
import React, { useState } from "react";
import ReactModal from "react-modal";
import { Box, Flex } from "rebass";
import { H3, Text } from "ui-components/index";
import { checkWordsInSequence } from "utils/helpers";
import { isEmpty } from "lodash";

const SectionListModal = ({
  modalStyle,
  setModal,
  mapData,
  data,
  changeField
}) => {
  const [modalData, setModalData] = useState(mapData);
  const filteredCountries = [];

  const CountryFlag = countryCode => {
    const flag = String.fromCodePoint(
      0x1f1e6 + countryCode.charCodeAt(0) - 0x41,
      0x1f1e6 + countryCode.charCodeAt(1) - 0x41
    );
    return flag;
  };

  const handleChange = (e, value) => {
    const currSequence = value.toLowerCase();
    mapData.forEach(section => {
      const filteredRows = section.rows.filter(country => {
        let match = checkWordsInSequence(
          country?.item_caption.toLowerCase(),
          currSequence.toLowerCase()
        );
        return match;
      });
      if (filteredRows.length > 0) {
        filteredCountries.push({
          section: section.section,
          rows: filteredRows
        });
      }
    });

    setModalData(filteredCountries);
  };

  return (
    <ReactModal
      style={modalStyle}
      isOpen={true}
      onRequestClose={() => {
        changeField("search", "");
        setModal(false);
      }}
    >
      <div data-testid="smart-render">
        <Flex
          p={2}
          justifyContent={"flex-end"}
          onClick={() => {
            changeField("search", "");
            setModal(false);
          }}
          sx={{
            cursor: "pointer",
            fontWeight: 600
          }}
        >
          <Text p={2}>X</Text>
        </Flex>
        <Flex alignItems="center" justifyContent="center">
          <Box justifySelf="flex-end"></Box>
          <H3>
            <FormattedMessage id={data?.headerTitle} />
          </H3>
        </Flex>

        <div
          style={{
            border: "1px solid #E4E7EB",
            marginTop: 18
          }}
        />

        <Box style={{ padding: "30px" }}>
          <TextField
            inputStyle={{
              border: "1px solid #F0F3F7",
              boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 12
            }}
            {...data}
            placeholder={data?.searchPlaceholder}
            onChange={handleChange}
          />

          <Flex alignItems="center" justifyContent="space-between" pb={4}>
            <Text color="#1400B8" fontWeight={700}>
              <FormattedMessage id={data?.leftSubTitle} />
            </Text>
            <Text color="#1400B8" fontWeight={700}>
              <FormattedMessage id={data?.rightSubTitle} />
            </Text>
          </Flex>

          {modalData.length > 0 ? (
            (modalData || []).map(
              record =>
                !isEmpty(record.rows) && (
                  <>
                    <Text color="#7B8794" fontWeight={700} pb={3}>
                      {record.section}
                    </Text>
                    {record.rows.map(row => (
                      <>
                        <Flex
                          alignItems="flex-start"
                          justifyContent="space-between"
                          pb={3}
                        >
                          <Flex alignItems="center" sx={{ gap: 1 }}>
                            {data?.showIcon && (
                              <span style={{ fontSize: 20 }}>
                                {CountryFlag(row.country_code)}
                              </span>
                            )}
                            <Text color="#333333" fontWeight={700}>
                              {row.item_caption}
                            </Text>
                          </Flex>
                          <Box sx={{ textAlign: "right" }}>
                            {row.item_descriptions?.map((des, idx) => (
                              <Text
                                color="#333333"
                                fontWeight={400}
                                fontSize={1}
                              >
                                {row.item_descriptions[idx]}
                              </Text>
                            ))}
                          </Box>
                        </Flex>
                        <div
                          style={{
                            border: "1px solid #E4E7EB",
                            marginBottom: 22
                          }}
                        />
                      </>
                    ))}
                  </>
                )
            )
          ) : (
            <Box>
              <Flex
                alignItems="center"
                justifyContent="center"
                backgroundColor="#eeecec"
                p={30}
                sx={{ borderRadius: 8 }}
              >
                <Text color="black" fontWeight={700}>
                  <FormattedMessage id={data?.emptySearch} />
                </Text>
              </Flex>
            </Box>
          )}
        </Box>
      </div>
    </ReactModal>
  );
};

SectionListModal.defaultProps = {
  modalStyle: [],
  setModal: () => {},
  mapData: [],
  data: {}
};

export default SectionListModal;
